import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { ActivityDestinationViewSearch } from '../../common/__generated__/api';

type Icon = ActivityDestinationViewSearch.Icon | ActivityDestinationViewSearch.______Icon | null;
type Mark = ActivityDestinationViewSearch.Mark | ActivityDestinationViewSearch._____Mark | null;

export interface IconMarkProps {
  icon?: Icon | null;
  mark?: Mark | null;
  defaultIconSize?: UitkIconSize;
  markSize?: UitkMarkSize;
  className?: string;
}

export const IconMark: React.FC<IconMarkProps> = ({
  icon,
  mark,
  defaultIconSize,
  markSize,
  className
}): JSX.Element => {
  const canRenderIcon = icon && !mark;
  const iconToRender = icon as ActivityDestinationViewSearch.Icon;
  const iconSize = iconToRender?.size && UitkIconSize[iconToRender?.size];
  markSize = markSize || UitkMarkSize.LARGE;
  defaultIconSize = defaultIconSize || UitkIconSize.LARGE;

  return (
    <React.Fragment>
      {mark && <UitkMark name={mark.id} size={markSize} className={className} />}
      {canRenderIcon && (
        <UitkIcon
          name={iconToRender?.id}
          size={iconSize || defaultIconSize}
          className={className}
          id={iconToRender?.id}
          description={iconToRender?.description}
        />
      )}
    </React.Fragment>
  );
};
